<template>
  <div class="w-100">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>
            Främmande arter i
            <GeoSelect
              ><span class="select-geo">{{
                $_currentGeoSection
              }}</span></GeoSelect
            >
          </h1>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12">
              <p class="body-3">
                Främmande arter är arter som avsiktligt eller oavsiktligt
                flyttats hit från andra platser. Många främmande arter har till
                exempel följt med lastfartygens barlastvatten, och en del har
                satts ut för att öka fångster vid människans jakt och fiske. I
                sina nya miljöer är vissa främmande arter harmlösa, medan andra
                utgör allvarliga hot mot de inhemska arterna.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="s in species"
          :key="s.id"
          :cols="$_colsWidth"
          class="d-flex child-flex"
        >
          <SpeciesCard class="" :species="s" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SpeciesCard from '@/components/SpeciesCard.vue'
import GeoSelect from '@/components/GeoSelect.vue'

import Misc from '@/mixins/Misc.js'
import Setup from '@/mixins/Setup.js'
import Geo from '@/mixins/GeoStuff.js'

export default {
  name: 'AlienSpecies',
  metaInfo: {
    title: 'Främmande arter'
  },
  mixins: [Setup, Misc, Geo],
  components: {
    SpeciesCard,
    GeoSelect
  },
  computed: {
    species() {
      const allSpecies = this.$store.getters.getAllSpecies
      return allSpecies.filter(species => species.alien === 'on')
    }
  }
}
</script>

<style lang="scss" scoped>
.select-geo {
  color: rgba(33, 162, 97, 1);
  text-decoration: underline;
}
</style>
